module.exports = {
  events: ['keydown', 'mousedown', 'touchstart'],
  idleTime: 45 * 60 * 1000, // 45 minut
  startAtIdle: false
}
